import React from 'react';
import { IconProps } from '.';

const SvgArrowDirectionLeft = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='m10.427 4.471 1.064 1.058-5.688 5.721H21v1.5H5.803l5.688 5.721-1.064 1.058L2.942 12l7.485-7.529Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowDirectionLeft;
